import React from 'react';
import {Navigate} from "react-router-dom";
import { useIsTokenValid} from "../../../helpers";

const Index = ({children}) => {
    return useIsTokenValid() ? children : <Navigate to="/login" />;
};

export default Index;